import React, {Component} from 'react';
import AdminTabs from './AdminTabs';
import jwt from 'jsonwebtoken';
import moment from 'moment';

class AdminChatSettingsView extends Component {
    
    constructor(props){
        super(props);
        
        this.state = {
            loaded: false,
            settings: [],
            changed: false
        }
    }
    
    componentDidMount = () => {
        this.props.getSettings();
    }
    
    componentDidUpdate = (props) => {
        if(props.settings !== this.props.settings){
            this.setState({settings: JSON.parse(JSON.stringify(this.props.settings))});
        }else if(JSON.stringify(this.props.settings) !== JSON.stringify(this.state.settings) && this.state.settings.length > 0 && this.state.loaded && this.state.changed === false){
            this.setState({changed: true});
        }else if(this.state.loaded && this.state.settings.length > 0 && this.state.changed === true){
            this.setState({changed: false});
        }
    }
    
    saveSettings = () => {
        let command = jwt.sign({
                        command: {
                        settings: this.state.settings,
                        profileId: this.props.user.user.Profile.id,
                        type: 'SAVE_SETTINGS',
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    if(this.props.socket.readyState){
                        this.props.socket.send(command);
                    }
    }
    
    
    
    
    render(){
        return (
            <div className="chat-box">
                <AdminTabs view="settings" />
                <div className="chat-contents-wrapper" style={{background: '#111', paddingBottom: '50px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <h2 className="font-22 text-white font-300 sm-bottom30">Settings</h2>
                            <a onClick={e => {
                                e.preventDefault();
                                this.saveSettings();
                                
                            }} className="btn btn-primary">Save Changes</a>
                        </div>
                        
                        
                        
                        
                        
                        
                        <div className="row">
                                <div className="col-sm-6">
    
                                    <div className="panel customPanel">
                                    	<div className="panel-heading">
                                    		<h3 className="panel-title">Bot Settings</h3>
                                    	</div>
                                    	<div className="panel-body">
                                            <div className="form-group">
                                                <div className="row">
                                                    {this.state.settings.filter(s => s.type === 'text').map(s => {
                                                        return (
                                                             <div className="col-sm-6">
                                                                <p className="">{s.title}</p>
                                                                <input type="text" className="form-control" value={s.value} onChange={e => {
                                                                    let {settings} = this.state;
                                                                    settings.filter(sc => sc.id === s.id)[0].value = e.target.value;
                                                                    this.setState({settings});
                                                                }} />
                                                            </div>
                                                        )
                                                        
                                                    })
                                                    }
                                                   
                                                  
                                                </div>
                                            </div>
                                            
                                            {this.state.settings.filter(s => s.type === 'number').map(s => {
                                                let titleS = s.title.split('{value}');
                                                return (
                                            
                                                    <div className="form-group">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <p className="">{titleS.length > 0 ? titleS[0] : ''} 
                                                                <input type="text" className="form-control" style={{display: "inline-block", width: "80px"}} value={s.value} onChange={e => {
                                                                    let {settings} = this.state;
                                                                    settings.filter(sc => sc.id === s.id)[0].value = e.target.value;
                                                                    this.setState({settings});
                                                                }} /> 
                                                                {titleS.length > 1 ? titleS[1] : ''} 
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }
                                    	</div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
    
                                    <div className="panel customPanel">
                                    	<div className="panel-heading">
                                    		<h3 className="panel-title">Chat Options</h3>
                                    	</div>
                                    	<div className="panel-body">
                                    		<div className="chat-options-admin">
                                                <ul className="flex-list">
                                                    {this.state.settings.filter(s => s.type === 'boolean').map(s => {
                                                        return (
                                                            <li>
                                                                <div>{s.title}</div>
                                                                <div>
                                                                    <input type="checkbox" className="ios8-switch ios-switch-small" id={`admin_settings_${s.id}`} checked={(s.value == true || s.value == "true")} onChange={e => {
                                                                    let {settings} = this.state;
                                                                    let toggleSetting = settings.filter(sc => sc.id === s.id)[0];
                                                                    toggleSetting.value = (toggleSetting.value == true || toggleSetting.value == "true") ? false : true;
                                                                    this.setState({settings});
                                                                }}  />
                                                                    <label htmlFor={`admin_settings_${s.id}`} ></label>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                    }
                                                    
                                                </ul>
                                            </div>
                                    	</div>
                                    </div>
    
    
    
    
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="font-22 text-white font-300 sm-bottom30">Automated Messages</h2>
                                    <p className="small hint">{'To have a message refer to a user, use the {name} tag in the automated message.'}</p>
                                </div>
                            
                                {this.state.settings.filter(s => s.type === 'message').map(s => {
                                    return (
                                        <div className="col-sm-6">
                                            <div className="panel customPanel">
                                                <div className="panel-heading">
                                                    <h3 className="panel-title">{s.title}</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <textarea className="form-control" style={{height: "100px"}} value={s.value} onChange={e => {
                                                                    let {settings} = this.state;
                                                                    settings.filter(sc => sc.id === s.id)[0].value = e.target.value;
                                                                    this.setState({settings});
                                                                }} ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                                
                        
                            
                            </div>
                    </div>
                </div>
            </div>
            )
    }
}

export default AdminChatSettingsView;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminChatSettingsView.js